
const MothersDayContent = () => {
    return (
        <>
            <h4>
                Annual Mother’s Day Research Appeal is launched 
            </h4>
            <p>
                The Annual Mother’s Day Research Appeal is launched with the help of the media. This Appeal encourages people to donate in lieu of a Mother’s Day Gift and in return receive a Mother’s Day card to give to their mother, which acknowledges their special gift. 
            </p>
        </>
    );
}

export default MothersDayContent;